import script from "./ChatButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatButton.vue?vue&type=script&setup=true&lang=ts"

import "./ChatButton.vue?vue&type=style&index=0&id=a842cc06&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a842cc06"]])

export default __exports__